import { useLayoutEffect, useMemo, useState, useEffect } from 'react';
import { SpecialOfferProductsProps, SopVersion, PromotionsNameMap } from './types/propTypes';
import SpecialOfferAlertMessage from './SpecialOfferAlertMessage/SpecialOfferAlertMessage';
import OffersDrawerV2 from './OffersDrawerNew/OffersDrawer';
import OffersDrawerV3, { getBenefitRowKey } from './OffersDrawerV3/OffersDrawer';

const SpecialOfferProducts = ({
  itemOptions,
  firedPromotions,
  version = SopVersion.TWO,
  hideBanner = false,
  selectedProducts,
  labels,
  onMount,
  onCloseDrawer,
  ...restProps
}: SpecialOfferProductsProps) => {
  const [showOffersDrawer, setShowOffersDrawer] = useState<boolean>(hideBanner);
  const [alertMsgSelectedQuantity, setAlertMsgSelectedQuantity] = useState<number>(0);
  const [promotionsNameMap, setPromotionsNameMap] = useState<PromotionsNameMap>({});

  const alertMsgTotalSelectableQty = useMemo(
    () => itemOptions?.reduce((res, cur) => res + Number(cur.totalSelectableQuantity), 0),
    [itemOptions],
  );

  useEffect(() => {
    onMount?.(() => setShowOffersDrawer(true));
  }, []);

  useEffect(() => {
    const map: PromotionsNameMap = {};
    firedPromotions?.forEach(({ promotion }) => {
      if (promotion?.name && promotion.promotionId) {
        map[promotion.promotionId] = promotion.name;
      }
    });
    setPromotionsNameMap(map);
  }, [itemOptions, firedPromotions]);

  useLayoutEffect(() => {
    if (version == SopVersion.ONE || !selectedProducts) {
      return;
    }
    let count = 0;
    Object.values(selectedProducts).forEach((item) => {
      Object.values(item).forEach(({ quantity }) => {
        count += quantity;
      });
    });
    setAlertMsgSelectedQuantity(count);
  }, [selectedProducts]);

  const handleDrawerClose = () => {
    setShowOffersDrawer(false);
    onCloseDrawer?.();
  };

  return (
    <>
      {itemOptions?.length && (
        <>
          {!hideBanner && (
            <SpecialOfferAlertMessage
              openOffersDrawer={() => setShowOffersDrawer(true)}
              selectedQuantity={alertMsgSelectedQuantity}
              totalSelectableQty={Number(alertMsgTotalSelectableQty)}
            />
          )}
          {showOffersDrawer && (
            <>
              {version === SopVersion.TWO && (
                <OffersDrawerV2
                  itemOptions={itemOptions}
                  selectedProducts={selectedProducts ?? {}}
                  promotionsNameMap={promotionsNameMap}
                  onCloseDrawer={handleDrawerClose}
                  {...labels}
                  {...restProps}
                />
              )}
              {version === SopVersion.THREE && (
                <OffersDrawerV3
                  itemOptions={itemOptions}
                  selectedProducts={selectedProducts ?? {}}
                  promotionsNameMap={promotionsNameMap}
                  onCloseDrawer={handleDrawerClose}
                  {...labels}
                  {...restProps}
                />
              )}
            </>
          )}
        </>
      )}
    </>
  );
};

export default SpecialOfferProducts;
export { getBenefitRowKey };
